export default __webpack_public_path__ + "static/media/pic_income.3cabde4f.png";